// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* fallow-ignore-file */
._cuD4cbj8VpGAeLLsTli {
  position: relative;
  display: flex;
  align-items: baseline;
  justify-content: center;
  font-family: var(--font-family-secondary, inherit);
  font-weight: 800;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
}
.Sx0PP54QA56plUSoEtZQ {
  position: relative;
  font-weight: 800;
  font-family: var(--font-family-secondary, inherit);
  -webkit-text-stroke: 0.03px !important;
  background-image: var(--campaign-gradient-gold-text-currency);
}
.k6Zjamphd2k4FTWRzslw {
  background-image: var(--campaign-gradient-gold-text);
  -webkit-background-clip: text;
  background-size: 100% 100%;
  background-position: 0 0;
  -webkit-text-fill-color: transparent;
  -webkit-text-stroke: 0.5px #FFDB10;
}
.eGxuc4L_cUvQ80RM_Cot[data-variant='prize-pool'] {
  filter: drop-shadow(0 3.5px 3.5px #000);
  letter-spacing: -1px;
}
/* Cap-alphabetic text-box trim: strips the font's ascent/descent dead space (the amount is
   digits only, so line-height: 1 leaves pure dead air below the glyphs) so the text bottom
   aligns to sibling icons instead of the font box. Both classes are flex items of
   .prizeContainer, so these margins aren't collapsed away as they would be on a plain inline
   element. Shared, font-metric-derived values — see campaign-variables.module.css. */
.eGxuc4L_cUvQ80RM_Cot,
.Sx0PP54QA56plUSoEtZQ {
  margin-top: var(--campaign-futura-trim-top);
  margin-bottom: var(--campaign-futura-trim-bottom);
}
/* prize-pool's drop-shadow + text-stroke extend past the glyph's own metrics (see the
   [data-variant='prize-pool'] rule above); the trim would clip those effects. Exempt this
   variant only. */
.eGxuc4L_cUvQ80RM_Cot[data-variant='prize-pool'],
.Sx0PP54QA56plUSoEtZQ[data-variant='prize-pool'] {
  margin-top: 0;
  margin-bottom: 0;
}
`, "",{"version":3,"sources":["webpack://./src/features/campaigns/components/shared/PrizeFundCampaign/css/base/PrizeFundCampaign.base.module.css"],"names":[],"mappings":"AAAA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,kDAAkD;EAClD,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kDAAkD;EAClD,sCAAsC;EACtC,6DAA6D;AAC/D;AACA;EACE,oDAAoD;EACpD,6BAA6B;EAC7B,0BAA0B;EAC1B,wBAAwB;EACxB,oCAAoC;EACpC,kCAAkC;AACpC;AACA;EACE,uCAAuC;EACvC,oBAAoB;AACtB;AACA;;;;qFAIqF;AACrF;;EAEE,2CAA2C;EAC3C,iDAAiD;AACnD;AACA;;kBAEkB;AAClB;;EAEE,aAAa;EACb,gBAAgB;AAClB","sourcesContent":["/* fallow-ignore-file */\n.prizeContainer {\n  position: relative;\n  display: flex;\n  align-items: baseline;\n  justify-content: center;\n  font-family: var(--font-family-secondary, inherit);\n  font-weight: 800;\n  line-height: 1;\n  text-align: center;\n  white-space: nowrap;\n}\n.currency {\n  position: relative;\n  font-weight: 800;\n  font-family: var(--font-family-secondary, inherit);\n  -webkit-text-stroke: 0.03px !important;\n  background-image: var(--campaign-gradient-gold-text-currency);\n}\n.prizeTextStyle {\n  background-image: var(--campaign-gradient-gold-text);\n  -webkit-background-clip: text;\n  background-size: 100% 100%;\n  background-position: 0 0;\n  -webkit-text-fill-color: transparent;\n  -webkit-text-stroke: 0.5px #FFDB10;\n}\n.prizeTextStyleAmount[data-variant='prize-pool'] {\n  filter: drop-shadow(0 3.5px 3.5px #000);\n  letter-spacing: -1px;\n}\n/* Cap-alphabetic text-box trim: strips the font's ascent/descent dead space (the amount is\n   digits only, so line-height: 1 leaves pure dead air below the glyphs) so the text bottom\n   aligns to sibling icons instead of the font box. Both classes are flex items of\n   .prizeContainer, so these margins aren't collapsed away as they would be on a plain inline\n   element. Shared, font-metric-derived values — see campaign-variables.module.css. */\n.prizeTextStyleAmount,\n.currency {\n  margin-top: var(--campaign-futura-trim-top);\n  margin-bottom: var(--campaign-futura-trim-bottom);\n}\n/* prize-pool's drop-shadow + text-stroke extend past the glyph's own metrics (see the\n   [data-variant='prize-pool'] rule above); the trim would clip those effects. Exempt this\n   variant only. */\n.prizeTextStyleAmount[data-variant='prize-pool'],\n.currency[data-variant='prize-pool'] {\n  margin-top: 0;\n  margin-bottom: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"prizeContainer": `_cuD4cbj8VpGAeLLsTli`,
	"currency": `Sx0PP54QA56plUSoEtZQ`,
	"prizeTextStyle": `k6Zjamphd2k4FTWRzslw`,
	"prizeTextStyleAmount": `eGxuc4L_cUvQ80RM_Cot`
};
export default ___CSS_LOADER_EXPORT___;
